
export var SCREEN_CONFIG = {
    dashboard: {
        title: "DASHBOARD"
    },
    tickets: {
        title: "TICKETS"
    },
    facilities: {
        title: "CLINICS"
    },
    facilities_add: {
        title: "CLINICS > ADD",

    },
    facilities_edit: {
        title: "CLINICS > EDIT"
    },
    facilities_admin: {
        title: "CLINICS > ADD > MOBI ADMIN"
    },
    facilities_admin_edit: {
        title: "CLINICS > EDIT > ADMIN"
    },
    questionnaire: {
        title: "SURVEYS"

    },
    settingsScreen: {
        title: "MY SETTINGS"
    },
    profileSettings: {
        title: "MY SETTINGS > PROFILE"
    },
    passwordSettings: {
        title: "MY SETTINGS > PASSWORD"
    },
    secureSettings: {
        title: "MY SETTINGS > SECURITY QUESTIONS"
    },
    additionUser: {
        title: "CLINIC SETTINGS > ADDITIONAL USERS"
    },
    logOut: {
        title: "LOGOUT"
    },
    moreNotifications: {
        title: "DASHBOARD > NOTIFICATIONS"
    },
    addPatients: {
        title: "PATIENTS > ADD PATIENTS"
    },
    patientsList: {
        title: "PATIENTS "
    },
    patientsDetails: {
        title: "PATIENTS"
    },
    PatientsSummery: {
        title: "Survey Summary"
    }
    ,
    staff: {
        title: "STAFF"
    },
    staffhome: {
        title: "HOME"
    },
    addStaff: {
        title: "STAFF > ADD STAFF"
    },
    viewStaff: {
        title: "STAFF > VIEW STAFF"
    },
    editStaff: {
        title: "STAFF > EDIT STAFF"
    },
    viewDetails: {
        title: "STAFF > VIEW DETAILS"
    },
    editFacility: {
        title: "CLINIC SETTINGS > EDIT CLINIC"
    },
    editmyProfile: {
        title: "SETTINGS > EDIT MY PROFILE"
    },
    addnewAdmin: {
        title: "CLINIC SETTINGS > ADD NEW ADMIN"
    },
    requestforDeactivation: {
        title: "CLINIC SETTINGS > REQUEST FOR DEACTIVATION"
    },
    newpasswordSetup: {
        title: "SETTINGS > NEW PASSWORD SETUP"
    },
    AddOptionalQuestion: {
        title: "PATIENT > OPTIONAL QUESTION(S)"
    },
    PatienSuerveyResponse: {
        title: "PATIENTS  > MOST RECENT RESPONSE"
    }




};
export var getConfigbyScreenName = (screenName) => {
    if (!screenName || !SCREEN_CONFIG[screenName]) {
        return SCREEN_CONFIG.defaultConfig;
    }

    return SCREEN_CONFIG[screenName];
};



/** WEBPACK FOOTER **
 ** ./src/config/screenConfig.js
 **/